$mol_icon_alert $mol_icon path \M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z
